package kz.dentalcrm.app.core.ui.icons

import androidx.compose.ui.graphics.vector.ImageVector
import kz.dentalcrm.app.core.ui.icons.defaulticons.Tenge
import kotlin.collections.List as ____KtList

public object DefaultIcons

private var __AllIcons: ____KtList<ImageVector>? = null

public val DefaultIcons.AllIcons: ____KtList<ImageVector>
  get() {
    if (__AllIcons != null) {
      return __AllIcons!!
    }
    __AllIcons= listOf(Tenge)
    return __AllIcons!!
  }
